import React, { Component, useEffect } from "react";
import CountUp from "react-countup";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  LOGOSdi,
  LOGOSatuDataIdn,
  LOGODinkominfo,
  LOGO,
  LOGOKabSigi,
  IMGBgFooter,
} from "src/assets/image";
import { setDataHomes } from "src/config/redux/action";
import { useHistory } from "react-router";
import "./style.css";

const Footer = ({ ...props }) => {
  const history = useHistory();
  const { dataHomes } = useSelector((state) => state.homeReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setDataHomes());
  }, [dispatch]);
  return dataHomes ? (
    <footer className="footer widget-footer clearfix">
      {props.children}
      <div className="first-footer ttm-bgcolor-skincolor ttm-bg ttm-bgimage-yes bg-img1">
        <div className="ttm-row-wrapper-bg-layer ttm-bg-layer" />
        <div className="container-xl">
          <div className="row align-items-md-center">
            <div className="col-lg-4 col-md-4 col-sm-12 order-md-2">
              <div className="footer-logo text-sm-center">
                <img
                  data-src={LOGO}
                  className="img-fluid"
                  alt="footer-logo"
                  src={LOGO}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 order-md-1 res-767-mt-20">
              <div className="text-left">
                {/* featured-icon-box */}
                <div className="featured-icon-box left-icon icon-align-top">
                  <div className="featured-icon">
                    {/* featured-icon */}
                    <div className="ttm-icon ttm-textcolor-white ttm-icon_element-size-md">
                      <i className="ti ti-location-pin" />
                      {/* ttm-icon */}
                    </div>
                  </div>
                  <div className="featured-content">
                    {/* featured-content */}
                    <div className="featured-desc">
                      <p>
                        Jalan Trans Palu-Palolo, Bora, Sigi Biromaru, Kabupaten Sigi, Sulawesi Tengah 94364
                      </p>
                    </div>
                  </div>
                </div>
                {/* featured-icon-box END */}
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 order-md-3 res-767-mt-20">
              <div className="text-sm-right">
                <a className="ttm-btn ttm-btn-size-md ttm-btn-style-border ttm-btn-color-white">
                  <i className="far fa-envelope" /> info@satudata.sigikab.go.id
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="second-footer ttm-textcolor-white"
        style={{ backgroundImage: `url(${IMGBgFooter})` }}
      >
        <div className="container-xl">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area">
              <div className="widget widget_text  clearfix">
                <h3 className="widget-title">Portal Satu Data</h3>
                <div className="textwidget widget-text">
                  Integrasi satu data mewujudkan Kabupaten Sigi Yang Maju, Mandiri Berbasis Ekonomi Kerakyatan
                </div>
                <div className="quicklink-box">
                  <div className="featured-icon-box left-icon">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-bgcolor-skincolor ttm-icon_element-size-md rounded-circle">
                        <span className="flaticon flaticon-clock" />
                        {/* ttm-icon */}
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>Total Kunjungan</p>
                      </div>
                      <div className="featured-title">
                        <h5>
                          <CountUp
                            start={0}
                            end={dataHomes.VisitorsCount}
                            duration={30}
                          />
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area">
              <div className="widget link-widget clearfix">
                <h3 className="widget-title">Organisasi</h3>
                <ul id="menu-footer-services">
                  {dataHomes.Agencies.map((v, i) => {
                    return (
                      <li key={i}>
                        <a href={`/organisasi/detail/${v.Slug}`}>{v.Name}</a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area res-991-mb-40 res-767-mb-0">
              <div className="widget widget_text clearfix">
                <h3 className="widget-title">Dataset Terbaru</h3>
                <ul className="widget-post ttm-recent-post-list">
                  {dataHomes.DatasetNews.map((v, i) => {
                    return (
                      <li key={i}>
                        <a href={`/data/detail/${v.DataHeaderSlug}`}>
                          {/* <img className="img-fluid" alt={v.FileLogo} src={v.FileLogo}  /> */}
                          {v.DataHeaderName}
                          <span className="post-date">
                            <i className="fa fa-calendar" />
                            {v.DataHeaderLastUpdate}
                          </span>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area res-767-mb-40">
              <div className="widget flicker_widget clearfix">
                <div className="textwidget widget-text">
                  <h5>Follow Us On</h5>
                  <div className="social-icons circle social-hover">
                    <ul className="list-inline">
                      <li className="social-facebook">
                        <a
                          href="https://www.facebook.com/profile.php?id=100015120135658"
                          className="tooltip-top rounded-circle"
                          target="_blank"
                          data-tooltip="Facebook"
                        >
                          <i className="fab fa-facebook-f" />
                        </a>
                      </li>
                      {/* <li className="social-twitter">
                        <a
                          href="https://youtube.com/channel/UCSdmXSFhL4tWTn2aAAPiP5g"
                          className="tooltip-top rounded-circle"
                          target="_blank"
                          data-tooltip="Youtube"
                        >
                          <i className="fab fa-youtube" />
                        </a>
                      </li> */}
                      <li className="social-linkedin">
                        <a
                          href="https://www.instagram.com/diskominfokabupatensigi/"
                          className=" tooltip-top rounded-circle"
                          target="_blank"
                          data-tooltip="Instagram"
                        >
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="widget flicker_widget clearfix">
                <div className="row">
                  <div className="col-md-12 text-center mb-3">
                    <a href="https://data.go.id/" target="_blank">
                      <img
                        src={LOGOSatuDataIdn}
                        style={{ width: "50px" }}
                        className="img-fluid"
                      />
                      <div className="text-white text-xs mt-2">
                        SATU DATA INDONESIA
                      </div>
                    </a>
                  </div>
                  <div className="col-md-6 text-center mb-3">
                    <a href="https://sigikab.go.id/" target="_blank">
                      <img
                        src={LOGOKabSigi}
                        style={{ height: "50px" }}
                        className="img-fluid"
                      />
                      <div className="text-white text-xs mt-2">
                        KABUPATEN SIGI
                      </div>
                    </a>
                  </div>
                  <div className="col-md-6 text-center mb-3">
                    <a href="https://diskominfo.sigikab.go.id/" target="_blank">
                      <img
                        src={LOGODinkominfo}
                        style={{ height: "50px" }}
                        className="img-fluid"
                      />
                      <div className="text-white text-xs mt-2">
                        DISKOMINFO
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-footer-text ttm-textcolor-white">
        <div className="container-xl">
          <div className="row copyright align-items-center res-767-text-center">
            <div className="col-md-6">
              <div>
                <span>
                  Copyright © {new Date().getFullYear()}{" "}
                  <a to="/" className="ml-2">
                    Pemerintah Kabupaten Sigi
                  </a>
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="text-md-right res-767-mt-10">
                <div className="d-lg-inline-flex text-right">
                  <span>
                    Design & Developed by
                    <i className="fa fa-heart ml-2 mr-2 text-danger" />
                    <a to="https://swg.co.id/" target="_blank">
                      {" "}
                      DISKOMINFO SIGI
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  ) : null;
};

export default Footer